import store from '@/store';
import Message from '../../models/Message';
import { newEvent } from '@/shared/utils/notification-title';
import { EventBus } from '@/event-bus';
import { notify } from '@/shared/utils/browser-notify';

export default class NewChatMessageEvent {
  constructor(event) {
    const { body } = event;
    const { agentId } = store.state.attendance.Attendance;
    const message = new Message({
      from: body.from,
      to: agentId,
      message: body.message.trim(),
      lastMessage: body.message.trim(),
      type: body.message_type,
      time: body.message_sent_at,
      protocol: body.protocol,
    });

    const notifyProtocol = body.protocol;
    const job = store.state.jobs.jobList.find(
      (job) => job.protocol == notifyProtocol,
    );
    if (!job) return;

    store.dispatch('jobs/newMessageChat', {
      identifier: message.from,
      message,
    });

    body.inbox = true;

    EventBus.$emit('new-message', body);
    EventBus.$emit('new-whatsapp-message-sound');
    newEvent();
    store.dispatch('jobs/alterClientStatusChat', message);
    store.dispatch('jobs/clientChatTyping', {
      from: message.from,
      typing: false,
    });

    if (
      store.state.attendance.Attendance.agentPreferences &&
      store.state.attendance.Attendance.agentPreferences.notifyChatMessage
    ) {
      const notifyProtocol = body.protocol;
      const job = store.state.jobs.jobList.find(
        (job) => job.protocol == notifyProtocol,
      );

      let title = job.contact ? job.contact.fullname : body.chat_identifier;
      if (!title) title = 'Mensagem de chat';

      const notification = {
        title,
        body: body.message.trim(),
        phoneNumber: '',
      };
      if (this.hasFocus(body.protocol)) notify(notification, true, 'chat');
    }
  }

  hasFocus(protocol) {
    if (document.visibilityState === 'hidden') return true;
    const currentPath = window.location.pathname;
    if (currentPath.includes(protocol)) return false;
    return true;
  }
}
